import React from "react";

const WebDevelopmentSection = () => {
  return (
    <section className="py-24 bg-slate-50 text-slate-800 relative">
      <div className="container mx-auto px-6 max-w-screen-xl">
        {/* HEADER */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-indigo-600 font-bold tracking-wider uppercase text-sm">
            Our Expertise
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-6 text-slate-900">
            Tailored Web Solutions for <br /> Every Sector
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Whether you run a hospital, a financial firm, or a startup, we
            engineer custom websites using the latest technologies like React,
            Next.js, and Node.js to guarantee unmatched performance, security,
            and scalability.
          </p>
        </div>

        {/* GRID CARDS*/}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* CARD 1*/}
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group border border-slate-100">
            <div className="w-14 h-14 bg-indigo-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
              {/* React/Cod */}
              <svg
                className="w-8 h-8 text-indigo-600 group-hover:text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3 text-slate-900">
              Modern Tech Stack
            </h3>
            <p className="text-slate-600 leading-relaxed">
              We utilize the latest frameworks to build lightning-fast,
              responsive, and interactive web applications that stand out in the
              digital market.
            </p>
          </div>

          {/* CARD 2*/}
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group border border-slate-100">
            <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
              {/* SECTORS ICONS*/}
              <svg
                className="w-8 h-8 text-blue-600 group-hover:text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3 text-slate-900">
              Industry-Specific Design
            </h3>
            <p className="text-slate-600 leading-relaxed">
              From E-commerce to healthcare portals, we design customized
              layouts that fit the unique needs and workflows of your specific
              business sector.
            </p>
          </div>

          {/* CARD 3*/}
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group border border-slate-100">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-teal-600 transition-colors duration-300">
              <svg
                className="w-8 h-8 text-teal-600 group-hover:text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3 text-slate-900">
              Built to Scale
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Our architecture ensures that as your business grows, your website
              grows with it without compromising on speed or user experience.
            </p>
          </div>
        </div>

        {/* CTA BUTTON*/}
        <div className="mt-16 text-center">
          <a
            href="/contact"
            className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-900 transition-colors shadow-lg"
          >
            Discuss Your Project
          </a>
        </div>
      </div>
    </section>
  );
};

export default WebDevelopmentSection;
